import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/close-square.svg")